import { useEffect, useRef, useState } from 'react';

/**
 * Chạy số từ giá trị cũ tới giá trị mới.
 *
 * 🔴 CHỈ dùng cho con số THỐNG KÊ trên thanh trên — doanh thu hôm nay, số khách
 *    đang mua. TUYỆT ĐỐI KHÔNG dùng cho "khách phải trả": thu ngân đọc con số đó
 *    lên thành tiếng, thấy số trung gian là đọc nhầm, và khách nghe một đằng trả
 *    một nẻo.
 *
 * Lần đầu có dữ liệu thì nhảy thẳng, không chạy từ 0 — mở màn hình lên mà thấy
 * doanh thu bò từ 0 tới 32 triệu là vừa chậm vừa vô nghĩa.
 */
export function useDemSo(dich: number, thoiGian = 550): number {
  const [hienTai, datHienTai] = useState(dich);
  const daCo = useRef(false);
  const tuDau = useRef(dich);
  const khung = useRef(0);

  useEffect(() => {
    tuDau.current = hienTai;
  }, [hienTai]);

  useEffect(() => {
    if (!daCo.current) {
      daCo.current = true;
      datHienTai(dich);
      return;
    }

    const tu = tuDau.current;
    const lech = dich - tu;
    if (lech === 0) return;

    const batDau = performance.now();
    const buoc = (luc: number) => {
      const t = Math.min(1, (luc - batDau) / thoiGian);
      // Cùng đường cong với CSS, để chuyển động trên màn hình nhất quán.
      const m = 1 - Math.pow(1 - t, 3);
      datHienTai(Math.round(tu + lech * m));
      if (t < 1) khung.current = requestAnimationFrame(buoc);
    };
    khung.current = requestAnimationFrame(buoc);
    return () => cancelAnimationFrame(khung.current);
    // `hienTai` cố ý KHÔNG nằm trong danh sách phụ thuộc: thêm vào là mỗi khung
    // hình lại khởi động một hoạt ảnh mới, và số không bao giờ tới đích.
  }, [dich, thoiGian]);

  return hienTai;
}
